// eslint-disable-next-line max-len
import {
  Address, ContactNumber,
  Coordinates,
  ImageFile,
  OpeningDays,
  PaymentMethod,
  Rating,
  ViewData, ViewDataExtra,
} from './shared';
import { CompanyEnrichment } from './extras';
import { SimplifiedAnalysis, VehicleAnalysis } from './vehicleAnalysis';

// Pricing
export enum PricingMethod {
  free = 'free',
  fixed = 'fixed',
  hourly = 'hourly'
}

// Amenities
export interface Amenity {
  id?: string;
  name: string;
  nameAr: string;
  tags: string;
  customImageLink: string;
  iconName: string;
}

// Establishments
export interface Vendor {
  id?: string;
  name: string;
  nameAr: string;
  description: string;
  descriptionAr?: string;
  websiteUrl?: string | null;
  image: ImageFile;
  address: Address;
  contactNumber: ContactNumber;
  rating: Rating;
  amenities: string[];
  // Payment
  acceptsCash: boolean;
  acceptsCard: boolean;
  basePrice: number;
  pricingMethod: PricingMethod;
  queuingSystem?: boolean;
  loginRequired?: boolean;
  // Extras
  companyEnrichment?: CompanyEnrichment;
}

export interface Shop {
  id?: string;
  image: ImageFile;
  name: string;
  nameAr?: string;
  description: string;
  descriptionAr?: string;
  floor: string;
  contactNumber: ContactNumber;
  openingDays?: OpeningDays;
  openingDaysAndHours: string;
  openingDaysAndHoursAr: string;
}

// Vehicles
export interface Vehicle extends SimplifiedAnalysis {
  id?: string;
  image?: ImageFile;
  damageImages?: ImageFile[];
  notes?: string;
}

export interface VehicleReport {
  vehicleImage: ImageFile;
  vehicleReport: VehicleAnalysis;
  simplifiedAnalysis: SimplifiedAnalysis;
  dateOfReport: number;
}

// Rides

export enum RideStatus {
  onHold = 'onHold',
  pickedUp = 'pickedUp',
  carParked = 'carParked',
  carRequested = 'carRequested',
  driverAssigned = 'driverAssigned',
  beingDelivered = 'beingDelivered',
  carArrived = 'carArrived',
  carReturned = 'carReturned',
  canceled = 'canceled',
  accident = 'accidentReported'
}

export interface ParkingDetails {
  parkingNumber: string;
  keySlotNumber: number;
  coordinates?: Coordinates;
}

export interface Ride {
  id?: string;
  customerId: string;
  pickupDriverId: string;
  deliveryDriverId: string | null;
  venueId: string;
  venue: ViewDataExtra;
  customer?: ViewData;
  customerIp: string;
  pickupDriver: ViewData;
  deliveryDriver: ViewData | null;
  vehicleData?: Vehicle;
  vehiclePlate?: string;
  parking?: ParkingDetails;
  status: RideStatus;
  createDate: number;
  isPayed: boolean;
  isReviewed: boolean;
  waitingTime: number;
  // Payment
  paymentMethod?: PaymentMethod;
  paymentAmount?: number;
  tip?: number;
  validatedByShop?: boolean;
  validateShopId?: string;
  // Logs
  requestedDate?: number;
  driverAssignedDate?: number;
  completedDate?: number;
  changeDate?: number;
  chatRoomId: string | null;
  customerDeleted?: boolean;
  // Override (set by vendor via overrideRideComplete cloud function)
  carOverrideTime?: number;
  overrideReason?: string;
}

// Review
export interface Review {
  customerId: string;
  rideId: string;
  driver1Id: string;
  driver2Id: string | null;
  customer?: ViewData;
  shopId?: string | null;
  review: string;
  stars: number;
}

// Custom Codes
export interface UserValidationCode {
  id?: string;
  vendorId: string;
  vendorName: string;
  code: string;
  lastUpdated: number;
}

export interface TemporaryPass {
  id?: string;
  vendorId: string;
  expiryDate: number;
}


export interface Queue {
  customerId: string
  customerName: string
  estimatedTime: number
  position: number
  requestedAt: number
  rideId: string
  status: string
  updatedAt: number
  vehiclePlate: string
} 